import { h } from 'preact'
import RadioInputGroup from '../../ui-components/RadioInputGroup'

interface Props {
  onUpdate: (value: number) => void,
  currentType: number
}

const types = [
  'Default (topics with conversations, questions and answers)', 
  'Ideation (submit and upvote topics)',
  'News (sorted from new to old by default, only moderators and above can post in this category)'
]
const typeMap: {
  [key: number]: string
} = {
  0: 'Default (topics with conversations, questions and answers)',
  2: 'Ideation (submit and upvote topics)',
  3: 'News (sorted from new to old by default, only moderators and above can post in this category)'
}

const typeInverseMap: {
  [key: string]: number
} = {
  'Default (topics with conversations, questions and answers)': 0,
  'Ideation (submit and upvote topics)': 2,
  'News (sorted from new to old by default, only moderators and above can post in this category)': 3
}

const CategoryType = (props : Props) => (
  <div className='form-group category-type'>
    <RadioInputGroup
      title={'Type'}
      options={types}
      onChange={(e: string) => { props.onUpdate(typeInverseMap[e]) }}
      value={typeMap[props.currentType] || types[0]}
    />
  </div>
)

export default CategoryType
